<div class="chip-input-wrapper" [ngClass]="{ disabled: disabled }">
  <mat-form-field class="full-page-width flex-half">
    <mat-label>Phone Number/Extension</mat-label>
    <mat-chip-grid #chipList [formControl]="chipsControl" [required]="required">
      @for (value of displayValues; track value) {
        <mat-chip-row
          [selectable]="false"
          [removable]="true"
          (removed)="removeValue(value)"
          >
          {{ getChipDisplay(value) }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
      }
      <input
        autocomplete="off"
        #chipInput
        type="text"
        [formControl]="inputControl"
        [lcsSingleSelect]="groupSelect"
        [required]="required"
        name="extension-group-filter"
        [matChipInputFor]="chipList"
        [allowManualInput]="true"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true"
        [openPanelOnFocus]="true"
        (matChipInputTokenEnd)="add($event)"
        (input)="onInputChange($event)"
        (blur)="removeErrors()"
        placeholder="Search"
        />
      </mat-chip-grid>
      @if (chipsControl.hasError('required')) {
        <mat-error> Please select an option </mat-error>
      }
      @if (chipsControl.hasError('invalidPhoneNumber')) {
        <mat-error>
          Please enter a valid phone number without hyphens or parentheses.
        </mat-error>
      }
      <div class="results-container">
        <ndt-extension-and-external-numbers-select
          #groupSelect
          (optionSelected)="selected($event)"
          [extensions]="filteredExtensions"
          [externalNumbers]="filteredPhoneNumubers"
          [extensionIdsToExclude]="extensionIdsToExclude"
          [autoActiveFirstOption]="false"
        ></ndt-extension-and-external-numbers-select>
      </div>
    </mat-form-field>
  </div>
